// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/core.regexp.escape.js
 **/